import queryString from "query-string";
import axiosRequest, { AxiosResponse, AxiosRequestConfig } from "axios";
import Cookies from "js-cookie";

export type AbstractRequest = (props: {
  options: AxiosRequestConfig;
  authenticate?: boolean;
  maxRetries?: number;
  mockRequest?: boolean;
}) => Promise<AxiosResponse>;

export const AuthUrl = import.meta.env.VITE_DATA_ROOM_API_URL + "/o";
export const ApiBaseUrl = import.meta.env.VITE_DATA_ROOM_API_URL + "/admin";

const TokenKey = "data_room_token";

export const setAuthToken = (token: string) => {
  Cookies.set(TokenKey, token);
};

const getAuthToken = () => {
  return Cookies.get(TokenKey);
};

const removeAuthToken = () => {
  Cookies.remove(TokenKey);
};

const serializeParams = (params: any) => queryString.stringify(params);

const attachOptions = async (options: AxiosRequestConfig, authenticate = true) => {
  const token = getAuthToken() || "";
  const selectedLanguage = typeof localStorage !== "undefined" ? localStorage.getItem("gc-language") || "en" : "en";
  return {
    ...options,
    paramsSerializer: (params: any) => serializeParams(params),
    headers: {
      Accept: 'application/json',
      'Accept-Language': selectedLanguage,
      ...(authenticate && {
        'Authorization': 'Bearer ' + token,
      }),
      'Content-Type': 'application/json',
      'Cache-Control': 'max-age=0',
      'Content-Security-Policy': 'default-src \'self\'; img-src https://*; child-src \'none\';',
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'SAMEORIGIN',
      'Referrer-Policy': 'strict-origin-when-cross-origin',
      ...options.headers,
    },
  };
};

export const request: AbstractRequest = async ({
  options,
  authenticate = true,
  maxRetries = 3,
  mockRequest = false,
}): Promise<AxiosResponse> => {
  if (mockRequest) {
    options.url = options.url?.replace(process.env.REACT_APP_GREENCAST_API_URL!, process.env.REACT_APP_MOCK_API_URL!);
  }
  const optionsWithHeader = await attachOptions(options, authenticate);
  return axiosRequest(optionsWithHeader).catch((e) => {
    if (e.response && e.response.status && (e.response.status === 403 || e.response.status === 401) && maxRetries > 0) {
      if ([401].includes(e.response.status)) {
        removeAuthToken();
      }
    }
    throw e;
  });
};
